import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Unit} from '../../../dashboard/monitoring/unit';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnitWriteOffFormService {

  constructor(
    private http: HttpClient
  ) {
  }

  doWriteOff(data: Unit, write_off_comment: string) {
    return this.http.patch(
      environment.apiBasepoint + 'unit/' + data.id,
      {
        written_off: true,
        write_off_comment: write_off_comment,
      }
    );
  }
}
